export function getGatewayErrors() {
    const errors = {
        "000.400.101": "Card not participating/authentication unavailable",
        "000.400.102": "User not enrolled",
        "000.400.103": "Technical Error in 3D system",
        "000.400.104": "Missing or malformed 3DSecure Configuration for Channel",
        "000.400.105": "Unsupported User Device - Authentication not possible",
        "000.400.106": "Invalid payer authentication response(PARes) in 3DSecure Transaction",
        "000.400.107": "Communication Error to Scheme Directory Server",
        "000.400.108": "Cardholder Not Found - card number provided is not found in the ranges of the issuer",
        "000.400.109": "Card is not enrolled for 3DS version 2",
        "000.400.111": "Data Only request failed",
        "000.400.200": "Risk management check communication error",
        "800.100.100": "transaction declined for unknown reason",
        "800.100.150": "transaction declined (refund on gambling tx not allowed)",
        "800.100.151": "transaction declined (invalid card)",
        "800.100.152": "transaction declined by authorization system",
        "800.100.153": "transaction declined (invalid CVV)",
        "800.100.154": "transaction declined (transaction marked as invalid)",
        "800.100.155": "transaction declined (amount exceeds credit)",
        "800.100.156": "transaction declined (format error)",
        "800.100.157": "transaction declined (wrong expiry date)",
        "800.100.158": "transaction declined (suspecting manipulation)",
        "800.100.159": "transaction declined (stolen card)",
        "800.100.160": "transaction declined (card blocked)",
        "800.100.161": "transaction declined (too many invalid tries)",
        "800.100.162": "transaction declined (limit exceeded)",
        "800.100.163": "transaction declined (maximum transaction frequency exceeded)",
        "800.100.164": "transaction declined (merchants limit exceeded)",
        "800.100.165": "transaction declined (card lost)",
        "800.100.166": "transaction declined (Incorrect personal identification number)",
        "800.100.167": "transaction declined (referencing transaction does not match)",
        "800.100.168": "transaction declined (restricted card)",
        "800.100.169": "transaction declined (card type is not processed by the authorization center)",
        "800.100.170": "transaction declined (transaction not permitted)",
        "800.100.171": "transaction declined (pick up card)",
        "800.100.172": "transaction declined (account blocked)",
        "800.100.173": "transaction declined (invalid currency, not processed by authorization center)",
        "800.100.174": "transaction declined (invalid amount)",
        "800.100.175": "transaction declined (invalid brand)",
        "800.100.176": "transaction declined (account temporarily not available. Please try again later)",
        "800.100.177": "transaction declined (amount field should not be empty)",
        "800.100.178": "transaction declined (PIN entered incorrectly too often)",
        "800.100.179": "transaction declined (exceeds withdrawal count limit)",
        "800.100.190": "transaction declined (invalid configuration data)",
        "800.100.191": "transaction declined (transaction in wrong state on aquirer side)",
        "800.100.192": "transaction declined (invalid CVV, Amount has still been reserved on the customer's card and will be released in a few business days. Please ensure the CVV code is accurate before retrying the transaction)",
        "800.100.195": "transaction declined (UserAccount Number/ID unknown)",
        "800.100.196": "transaction declined (registration error)",
        "800.100.197": "transaction declined (registration cancelled externally)",
        "800.100.198": "transaction declined (invalid holder)",
        "800.100.199": "transaction declined (invalid tax number)",
        "800.100.200": "Refer to Payer due to reason not specified",
        "800.100.201": "Account or Bank Details Incorrect",
        "800.100.202": "Account Closed",
        "800.100.203": "Insufficient Funds",
        "800.100.204": "Mandate Expired",
        "800.100.205": "Mandate Discarded",
        "800.100.206": "Refund of an authorized payment requested by the customer",
        "800.100.207": "Refund requested",
        "800.100.208": "Direct debit not enabled for the specified account or bank",
        "800.100.402": "cc/bank account holder not valid",
        "800.100.403": "transaction declined (revocation of authorisation order)",
        "800.100.500": "Card holder has advised his bank to stop this recurring payment",
        "800.100.501": "Card holder has advised his bank to stop all recurring payments for this merchant",
        "800.700.100": "transaction for the same session is currently being processed, please try again later.",
        "800.700.101": "family name too long",
        "800.700.201": "given name too long",
        "800.700.500": "company name too long",
        "800.800.102": "Invalid street",
        "800.800.202": "Invalid zip",
        "800.800.302": "Invalid city",
        "000.400.030": "Transaction partially failed (please reverse manually due to failed automatic reversal)",
        "900.100.100": "unexpected communication error with connector/acquirer",
        "900.100.200": "error response from connector/acquirer",
        "900.100.201": "error on the external gateway (e.g. on the part of the bank, acquirer,...)",
        "900.100.202": "invalid transaction flow, the requested function is not applicable for the referenced transaction",
        "900.100.203": "error on the internal gateway",
        "900.100.204": "Error during message parsing",
        "900.100.300": "timeout, uncertain result",
        "900.100.301": "Transaction timed out without response from connector/acquirer. It was reversed",
        "900.100.310": "Transaction timed out due to internal system misconfiguration. Request to acquirer has not been sent",
        "900.100.400": "timeout at connectors/acquirer side",
        "900.100.500": "timeout at connectors/acquirer side (try later)",
        "900.100.600": "connector/acquirer currently down",
        "900.100.700": "error on the external service provider",
        "900.200.100": "Message Sequence Number of Connector out of sync",
        "900.300.600": "user session timeout",
        "900.400.100": "unexpected communication error with external risk provider",
        "600.100.100": "Unexpected Integrator Error (Request could not be processed)",
        "800.500.100": "direct debit transaction declined for unknown reason",
        "800.500.110": "Unable to process transaction - ran out of terminalIds - please contact acquirer",
        "800.600.100": "transaction is being already processed",
        "800.800.400": "Connector/acquirer system is under maintenance",
        "800.800.800": "The payment system is currenty unavailable, please contact support in case this happens again",
        "800.800.801": "The payment system is currenty unter maintenance. Please apologize for the inconvenience this may cause. If you were not informed of this maintenance window in advance, contact your sales representative",
        "999.999.888": "UNDEFINED PLATFORM DATABASE ERROR",
        "999.999.999": "UNDEFINED CONNECTOR/ACQUIRER ERROR",
        "100.395.101": "Bank not supported for Giropay",
        "100.395.102": "Account not enabled for Giropay e.g. test account",
        "100.395.501": "Previously pending online transfer transaction timed out",
        "100.395.502": "Acquirer/Bank reported timeout on online transfer transaction",
        "100.396.101": "Cancelled by user",
        "100.396.102": "Not confirmed by user",
        "100.396.103": "Previously pending transaction timed out",
        "100.396.104": "Uncertain status - probably cancelled by user",
        "100.396.106": "User did not agree to payment method terms",
        "100.396.201": "Cancelled by merchant",
        "100.397.101": "Cancelled by user due to external update",
        "100.397.102": "Rejected by connector/acquirer due to external update",
        "300.100.100": "Transaction declined (additional customer authentication required)",
        "100.370.100": "transaction declined",
        "100.370.110": "transaction must be executed for German address",
        "100.370.111": "system error( possible incorrect/missing input data)",
        "100.380.100": "transaction declined",
        "100.380.101": "transaction contains no risk management part",
        "100.380.110": "transaction must be executed for German address",
        "100.380.201": "no risk management process type specified",
        "100.380.305": "no frontend information provided for asynchronous transaction",
        "100.380.306": "no authentication data provided in risk management transaction",
        "100.380.401": "User Authentication Failed",
        "100.380.501": "risk management transaction timeout",
        "100.400.000": "transaction declined (Wrong Address)",
        "100.400.001": "transaction declined (Wrong Identification)",
        "100.400.002": "transaction declined (Insufficient credibility score)",
        "100.400.005": "transaction must be executed for German address",
        "100.400.007": "System error ( possible incorrect/missing input data)",
        "100.400.020": "transaction declined",
        "100.400.021": "transaction declined for country",
        "100.400.030": "transaction not authorized. Please check manually",
        "100.400.039": "transaction declined for other error",
        "100.400.040": "authorization failure",
        "100.400.041": "transaction must be executed for German address",
        "100.400.042": "transaction declined by SCHUFA (Insufficient credibility score)",
        "100.400.043": "transaction declined because of missing obligatory parameter(s)",
        "100.400.044": "transaction not authorized. Please check manually",
        "100.400.045": "SCHUFA result not definite. Please check manually",
        "100.400.051": "SCHUFA system error (possible incorrect/missing input data)",
        "100.400.060": "authorization failure",
        "100.400.061": "transaction declined (Insufficient credibility score)",
        "100.400.063": "transaction declined because of missing obligatory parameter(s)",
        "100.400.064": "transaction must be executed for Austrian, German or Swiss address",
        "100.400.065": "result ambiguous. Please check manually",
        "100.400.071": "system error (possible incorrect/missing input data)",
        "100.400.080": "authorization failure",
        "100.400.081": "transaction declined",
        "100.400.083": "transaction declined because of missing obligatory parameter(s)",
        "100.400.084": "transaction can not be executed for given country",
        "100.400.085": "result ambiguous. Please check manually",
        "100.400.086": "transaction declined (Wrong Address)",
        "100.400.087": "transaction declined (Wrong Identification)",
        "100.400.091": "system error (possible incorrect/missing input data)",
        "100.400.100": "transaction declined - very bad rating",
        "100.400.120": "authorization failure",
        "100.400.121": "account blacklisted",
        "100.400.122": "transaction must be executed for valid German account",
        "100.400.123": "transaction declined because of missing obligatory parameter(s)",
        "100.400.130": "system error (possible incorrect/missing input data)",
        "100.400.139": "system error (possible incorrect/missing input data)",
        "100.400.140": "transaction declined by GateKeeper",
        "100.400.141": "Challenge by ReD Shield",
        "100.400.142": "Deny by ReD Shield",
        "100.400.143": "Noscore by ReD Shield",
        "100.400.144": "ReD Shield data error",
        "100.400.145": "ReD Shield connection error",
        "100.400.146": "Line item error by ReD Shield",
        "100.400.147": "Payment void and transaction denied by ReD Shield",
        "100.400.148": "Payment void and transaction challenged by ReD Shield",
        "100.400.149": "Payment void and data error by ReD Shield",
        "100.400.150": "Payment void and connection error by ReD Shield",
        "100.400.151": "Payment void and line item error by ReD Shield",
        "100.400.152": "Payment void and error returned by ReD Shield",
        "100.400.241": "Challenged by Threat Metrix",
        "100.400.242": "Denied by Threat Metrix",
        "100.400.243": "Invalid sessionId",
        "100.400.260": "authorization failure",
        "100.400.300": "abort checkout process",
        "100.400.301": "reenter age/birthdate",
        "100.400.302": "reenter address (packstation not allowed)",
        "100.400.303": "reenter address",
        "100.400.304": "invalid input data",
        "100.400.305": "invalid foreign address",
        "100.400.306": "delivery address error",
        "100.400.307": "offer only secure methods of payment",
        "100.400.308": "offer only secure methods of payment; possibly abort checkout",
        "100.400.309": "confirm corrected address; if not confirmed, offer secure methods of payment only",
        "100.400.310": "confirm bank account data; if not confirmed, offer secure methods of payment only",
        "100.400.311": "transaction declined (format error)",
        "100.400.312": "transaction declined (invalid configuration data)",
        "100.400.313": "currency field is invalid or missing",
        "100.400.314": "amount invalid or empty",
        "100.400.315": "invalid or missing email address (probably invalid syntax)",
        "100.400.316": "transaction declined (card missing)",
        "100.400.317": "transaction declined (invalid card)",
        "100.400.318": "invalid IP number",
        "100.400.319": "transaction declined by risk system",
        "100.400.320": "shopping cart data invalid or missing",
        "100.400.321": "payment type invalid or missing",
        "100.400.322": "encryption method invalid or missing",
        "100.400.323": "certificate invalid or missing",
        "100.400.324": "Error on the external risk system",
        "100.400.325": "External risk system not available",
        "100.400.326": "Risk bank account check unsuccessful",
        "100.400.327": "Risk report unsuccessful",
        "100.400.328": "Risk report unsuccessful (invalid data)",

        "800.400.100": "AVS Check Failed",
        "800.400.101": "Mismatch of AVS street value",
        "800.400.102": "Mismatch of AVS street number",
        "800.400.103": "Mismatch of AVS PO box value fatal",
        "800.400.104": "Mismatch of AVS zip code value fatal",
        "800.400.105": "Mismatch of AVS settings (AVSkip, AVIgnore, AVSRejectPolicy) value",
        "800.400.110": "AVS Check Failed. Amount has still been reserved on the customer's card and will be released in a few business days. Please ensure the billing address is accurate before retrying the transaction.",
        "800.400.150": "Implausible address data",
        "800.400.151": "Implausible address state data",

        //"100.380.401": "User Authentication Failed",
        "100.390.101": "purchase amount/currency mismatch",
        "100.390.102": "PARes Validation failed",
        "100.390.103": "PARes Validation failed - problem with signature",
        "100.390.104": "XID mismatch",
        "100.390.105": "Transaction rejected because of technical error in 3DSecure system",
        "100.390.106": "Transaction rejected because of error in 3DSecure configuration",
        "100.390.107": "Transaction rejected because cardholder authentication unavailable",
        "100.390.108": "Transaction rejected because merchant not participating in 3DSecure program",
        "100.390.109": "Transaction rejected because of VISA status 'U' or AMEX status 'N' or 'U' in 3DSecure program",
        "100.390.110": "Cardholder Not Found - card number provided is not found in the ranges of the issuer",
        "100.390.111": "Communication Error to Scheme Directory Server",
        "100.390.112": "Technical Error in 3D system",
        "100.390.113": "Unsupported User Device - Authentication not possible",
        "100.390.114": "Not authenticated because the issuer is rejecting authentication",
        "100.390.115": "Authentication failed due to invalid message format",
        "100.390.116": "Access denied to the authentication system",
        "100.390.117": "Authentication failed due to invalid data fields",
        "100.390.118": "Authentication failed due to suspected fraud",
        "800.400.200": "Invalid Payer Authentication in 3DSecure transaction",

        "100.100.701": "suspecting fraud, this card may not be processed",
        "800.200.159": "account or user is blacklisted (card stolen)",
        "800.200.160": "account or user is blacklisted (card blocked)",
        "800.200.165": "account or user is blacklisted (card lost)",
        "800.200.202": "account or user is blacklisted (account closed)",
        "800.200.208": "account or user is blacklisted (account blocked)",
        "800.200.220": "account or user is blacklisted (fraudulent transaction)",
        "800.300.101": "account or user is blacklisted",
        "800.300.102": "country blacklisted",
        "800.300.200": "email is blacklisted",
        "800.300.301": "ip blacklisted",
        "800.300.302": "ip is anonymous proxy",
        "800.300.401": "bin blacklisted",
        "800.300.500": "transaction temporary blacklisted (too many tries invalid CVV)",
        "800.300.501": "transaction temporary blacklisted (too many tries invalid expire date)",
        "800.310.200": "Account closed",
        "800.310.210": "Account not found",
        "800.310.211": "Account not found (BIN/issuer not participating)",

        "800.110.100": "duplicate transaction",
        "800.120.100": "Rejected by Throttling.",
        "800.120.101": "maximum number of transactions per account already exceeded",
        "800.120.102": "maximum number of transactions per ip already exceeded",
        "800.120.103": "maximum number of transactions per email already exceeded",
        "800.120.200": "maximum total volume of transactions already exceeded",
        "800.120.201": "maximum total volume of transactions per account already exceeded",
        "800.120.202": "maximum total volume of transactions per ip already exceeded",
        "800.120.203": "maximum total volume of transactions per email already exceeded",
        "800.120.300": "chargeback rate per bin exceeded",
        "800.120.401": "maximum number of transactions or total volume for configured MIDs or CIs exceeded",
        "800.130.100": "Transaction with same TransactionId already exists",
        "800.140.100": "maximum number of registrations per mobile number exceeded",
        "800.140.101": "maximum number of registrations per email address exceeded",
        "800.140.110": "maximum number of registrations of mobile per credit card number exceeded",
        "800.140.111": "maximum number of registrations of credit card number per mobile exceeded",
        "800.140.112": "maximum number of registrations of email per credit card number exceeded",
        "800.140.113": "maximum number of registrations of credit card number per email exceeded",
        "800.150.100": "Account Holder does not match Customer Name",
        "800.160.100": "Invalid payment data for configured Shopper Dispatching Type",
        "800.160.110": "Invalid payment data for configured Payment Dispatching Type",
        "800.160.120": "Invalid payment data for configured Recurring Transaction Dispatching Type",
        "800.160.130": "Invalid payment data for configured TicketSize Dispatching Type",

        "500.100.201": "Channel/Merchant is disabled (no processing possible)",
        "500.100.202": "Channel/Merchant is new (no processing possible yet)",
        "500.100.203": "Channel/Merchant is closed (no processing possible)",
        "500.100.301": "Merchant-Connector is disabled (no processing possible)",
        "500.100.302": "Merchant-Connector is new (no processing possible yet)",
        "500.100.303": "Merchant-Connector is closed (no processing possible)",
        "500.100.304": "Merchant-Connector is disabled at gateway (no processing possible)",
        "500.100.401": "Connector is unavailable (no processing possible)",
        "500.100.402": "Connector is new (no processing possible yet)",
        "500.100.403": "Connector is unavailable (no processing possible)",
        "500.200.101": "No target account configured for DD transaction",
        "600.200.100": "invalid Payment Method",
        "600.200.200": "Unsupported Payment Method",
        "600.200.201": "Channel/Merchant not configured for this payment method",
        "600.200.202": "Channel/Merchant not configured for this payment type",
        "600.200.300": "invalid Payment Type",
        "600.200.310": "invalid Payment Type for given Payment Method",
        "600.200.400": "Unsupported Payment Type",
        "600.200.500": "Invalid payment data. You are not configured for this currency or sub type (country or brand)",
        "600.200.501": "Invalid payment data for Recurring transaction. Merchant or transaction data has wrong recurring configuration.",
        "600.200.600": "invalid payment code (type or method)",
        "600.200.700": "invalid payment mode (you are not configured for the requested transaction mode)",
        "600.200.800": "invalid brand for given payment method and payment mode (you are not configured for the requested transaction mode)",
        "600.200.810": "invalid return code provided",
        "600.300.101": "Merchant key not found",
        "600.300.200": "merchant source IP address not whitelisted",
        "600.300.210": "merchant notificationUrl not whitelisted",
        "600.300.211": "shopperResultUrl not whitelisted",
        "800.121.100": "Channel not configured for given source type. Please contact your account manager.",
        "800.121.200": "Secure Query is not enabled for this entity. Please contact your account manager.",

        "100.150.100": "request contains no Account data and no registration id",
        "100.150.101": "invalid format for specified registration id (must be uuid format)",
        "100.150.200": "registration does not exist",
        "100.150.201": "registration is not confirmed yet",
        "100.150.202": "registration is already deregistered",
        "100.150.203": "registration is not valid, probably initially rejected",
        "100.150.204": "account registration reference pointed to no registration transaction",
        "100.150.205": "referenced registration does not contain an account",
        "100.150.300": "payment only allowed with valid initial registration",
        "100.350.100": "referenced session is REJECTED (no action possible).",
        "100.350.101": "referenced session is CLOSED (no action possible)",
        "100.350.200": "undefined session state",
        "100.350.201": "referencing a registration through reference id is not applicable for this payment type",
        "100.350.301": "confirmation (CF) must be registered (RG) first",
        "100.350.302": "session already confirmed (CF)",
        "100.350.303": "cannot deregister (DR) unregistered account and/or customer",
        "100.350.310": "cannot confirm (CF) session via XML",
        "100.350.311": "cannot confirm (CF) on a registration passthrough channel",
        "100.350.312": "cannot do passthrough on non-internal connector",
        "100.350.313": "registration of this type has to provide confirmation url",
        "100.350.314": "customer could not be notified of pin to confirm registration (channel)",
        "100.350.315": "customer could not be notified of pin to confirm registration (sending failed)",
        "100.350.316": "cannot extend the token (TE) on unregistered account",
        "100.350.400": "no or invalid PIN (email/SMS/MicroDeposit authentication) entered",
        "100.350.500": "unable to obtain personal (virtual) account - most likely no more accounts available",
        "100.350.601": "registration is not allowed to reference another transaction",
        "100.350.602": "Registration is not allowed for recurring payment migration",

        "100.250.100": "job contains no execution information",
        "100.250.105": "invalid or missing action type",
        "100.250.106": "invalid or missing duration unit",
        "100.250.107": "invalid or missing notice unit",
        "100.250.110": "missing job execution",
        "100.250.111": "missing job expression",
        "100.250.120": "invalid execution parameters, combination does not conform to standard",
        "100.250.121": "invalid execution parameters, hour must be between 0 and 23",
        "100.250.122": "invalid execution parameters, minute and seconds must be between 0 and 59",
        "100.250.123": "invalid execution parameters, Day of month must be between 1 and 31",
        "100.250.124": "invalid execution parameters, month must be between 1 and 12",
        "100.250.125": "invalid execution parameters, Day of week must be between 1 and 7",
        "100.250.250": "Job tag missing",
        "100.360.201": "unknown schedule type",
        "100.360.300": "cannot schedule(SD) unscheduled job",
        "100.360.303": "cannot deschedule(DS) unscheduled job",
        "100.360.400": "schedule module not configured for LIVE transaction mode",

        "700.100.100": "reference id not existing",
        "700.100.200": "non matching reference amount",
        "700.100.300": "invalid amount (probably too large)",
        "700.100.400": "referenced payment method does not match with requested payment method",
        "700.100.500": "referenced payment currency does not match with requested payment currency",
        "700.100.600": "referenced mode does not match with requested payment mode",
        "700.100.700": "referenced transaction is of inappropriate type",
        "700.100.701": "referenced a DB transaction without explicitly providing an account. Not allowed to used referenced account.",
        "700.100.710": "cross-linkage of two transaction-trees",
        "700.300.100": "referenced tx can not be refunded, captured or reversed (invalid type)",
        "700.300.200": "referenced tx was rejected",
        "700.300.300": "referenced tx can not be refunded, captured or reversed (already refunded, captured or reversed)",
        "700.300.400": "referenced tx can not be captured (cut off time reached)",
        "700.300.500": "chargeback error (multiple chargebacks)",
        "700.300.600": "referenced tx can not be refunded or reversed (was chargebacked)",
        "700.300.700": "referenced tx can not be reversed (reversal not possible anymore)",
        "700.300.800": "referenced tx can not be voided",
        "700.400.000": "serious workflow error (call support)",
        "700.400.100": "cannot capture (PA value exceeded, PA reverted or invalid workflow?)",
        "700.400.101": "cannot capture (Not supported by authorization system)",
        "700.400.200": "cannot refund (refund volume exceeded or tx reversed or invalid workflow?)",
        "700.400.300": "cannot reverse (already refunded|reversed, invalid workflow or amount exceeded)",
        "700.400.400": "cannot chargeback (already chargebacked or invalid workflow?)",
        "700.400.402": "chargeback can only be generated internally by the payment system",
        "700.400.410": "cannot reversal chargeback (chargeback is already reversaled or invalid workflow?)",
        "700.400.411": "cannot reverse chargeback or invalid workflow (second chargeback)",
        "700.400.420": "cannot reversal chargeback (no chargeback existing or invalid workflow?)",
        "700.400.510": "capture needs at least one successful transaction of type (PA)",
        "700.400.520": "refund needs at least one successful transaction of type (CP or DB or RB or RC)",
        "700.400.530": "reversal needs at least one successful transaction of type (CP or DB or RB or PA)",
        "700.400.540": "reconceile needs at least one successful transaction of type (CP or DB or RB)",
        "700.400.550": "chargeback needs at least one successful transaction of type (CP or DB or RB)",
        "700.400.560": "receipt needs at least one successful transaction of type (PA or CP or DB or RB)",
        "700.400.561": "receipt on a registration needs a successfull registration in state 'OPEN'",
        "700.400.562": "receipts are configured to be generated only internally by the payment system",
        "700.400.565": "finalize needs at least one successful transaction of type (PA or DB)",
        "700.400.570": "cannot reference a waiting/pending transaction",
        "700.400.580": "cannot find transaction",
        "700.400.590": "installment needs at least one successful transaction of type (DB or PA)",
        "700.400.600": "finalize needs at least one successful transaction of type (IN, DB, PA or CD)",
        "700.400.700": "initial and referencing channel-ids do not match",
        "700.450.001": "cannot transfer money from one account to the same account",
        "700.500.001": "referenced session contains too many transactions",
        "700.500.002": "capture or preauthorization appears too late in referenced session",
        "700.500.003": "test accounts not allowed in production",
        "700.500.004": "cannot refer a transaction which contains deleted customer information",

        "100.300.101": "invalid test mode (please use LIVE or INTEGRATOR_TEST or CONNECTOR_TEST)",
        "100.300.200": "transaction id too long",
        "100.300.300": "invalid reference id",
        "100.300.400": "missing or invalid channel id",
        "100.300.401": "missing or invalid sender id",
        "100.300.402": "missing or invalid version",
        "100.300.501": "invalid response id",
        "100.300.600": "invalid or missing user login",
        "100.300.601": "invalid or missing user pwd",
        "100.300.700": "invalid relevance",
        "100.300.701": "invalid relevance for given payment type",
        "100.370.121": "no or unknown ECI Type defined in Authentication",
        "100.370.122": "parameter with null key provided in 3DSecure Authentication",
        "100.370.123": "no or unknown verification type defined in 3DSecure Authentication",
        "100.370.124": "unknown parameter key in 3DSecure Authentication",
        "100.370.125": "Invalid 3DSecure Verification_ID. Must have Base64 encoding a Length of 28 digits",
        "100.370.131": "no or unknown authentication type defined in Transaction/Authentication@type",
        "100.370.132": "no result indicator defined Transaction/Authentication/resultIndicator",
        "100.500.101": "payment method invalid",
        "100.500.201": "payment type invalid",
        "100.500.301": "invalid due date",
        "100.500.302": "invalid mandate date of signature",
        "100.500.303": "invalid mandate id",
        "100.500.304": "invalid mandate external id",
        "100.600.500": "usage field too long",
        "100.900.500": "invalid recurrence mode",
        "200.100.101": "invalid Request Message. No valid XML. XML must be url-encoded! maybe it contains a not encoded ampersand or something similar.",
        "200.100.102": "invalid Request. XML load missing (XML string must be sent within parameter 'load')",
        "200.100.103": "invalid Request Message. The request contains structural errors",
        "200.100.150": "transaction of multirequest not processed because of subsequent problems",
        "200.100.151": "multi-request is allowed with a maximum of 10 transactions only",
        "200.100.199": "Wrong Web Interface / URL used. Please check out the Tech Quick Start Doc Chapter 3.",
        "200.100.201": "invalid Request/Transaction tag (not present or [partially] empty)",
        "200.100.300": "invalid Request/Transaction/Payment tag (no or invalid code specified)",
        "200.100.301": "invalid Request/Transaction/Payment tag (not present or [partially] empty)",
        "200.100.302": "invalid Request/Transaction/Payment/Presentation tag (not present or [partially] empty)",
        "200.100.401": "invalid Request/Transaction/Account tag (not present or [partially] empty)",
        "200.100.402": "invalid Request/Transaction/Account(Customer, Relevance) tag (one of Account/Customer/Relevance must be present)",
        "200.100.403": "invalid Request/Transaction/Analysis tag (Criterions must have a name and value)",
        "200.100.404": "invalid Request/Transaction/Account (must not be present)",
        "200.100.501": "invalid or missing customer",
        "200.100.502": "invalid Request/Transaction/Customer/Name tag (not present or [partially] empty)",
        "200.100.503": "invalid Request/Transaction/Customer/Contact tag (not present or [partially] empty)",
        "200.100.504": "invalid Request/Transaction/Customer/Address tag (not present or [partially] empty)",
        "200.100.601": "invalid Request/Transaction/(ApplePay|GooglePay) tag (not present or [partially] empty)",
        "200.100.602": "invalid Request/Transaction/(ApplePay|GooglePay)/PaymentToken tag (not present or [partially] empty)",
        "200.100.603": "invalid Request/Transaction/(ApplePay|GooglePay)/PaymentToken tag (decryption error)",
        "200.200.106": "duplicate transaction. Please verify that the UUID is unique",
        "200.300.403": "Invalid HTTP method",
        "200.300.404": "invalid or missing parameter",
        "200.300.405": "Duplicate entity",
        "200.300.406": "Entity not found",
        "200.300.407": "Entity not specific enough",
        "800.900.100": "sender authorization failed",
        "800.900.101": "invalid email address (probably invalid syntax)",
        "800.900.200": "invalid phone number (has to start with a digit or a '+', at least 7 and max 25 chars long)",
        "800.900.201": "unknown channel",
        "800.900.300": "invalid authentication information",
        "800.900.301": "user authorization failed, user has no sufficient rights to process transaction",
        "800.900.302": "Authorization failed",
        "800.900.303": "No token created",
        "800.900.399": "Secure Registration Problem",
        "800.900.401": "Invalid IP number",
        "800.900.450": "Invalid birthdate",

        "100.800.100": "request contains no street",
        "100.800.101": "The combination of street1 and street2 must not exceed 201 characters.",
        "100.800.102": "The combination of street1 and street2 must not contain only numbers.",
        "100.800.200": "request contains no zip",
        "100.800.201": "zip too long",
        "100.800.202": "invalid zip",
        "100.800.300": "request contains no city",
        "100.800.301": "city too long",
        "100.800.302": "invalid city",
        "100.800.400": "invalid state/country combination",
        "100.800.401": "state too long",
        "100.800.500": "request contains no country",
        "100.800.501": "invalid country",

        "100.700.100": "customer.surname may not be null",
        "100.700.101": "customer.surname length must be between 0 and 50",
        "100.700.200": "customer.givenName may not be null",
        "100.700.201": "customer.givenName length must be between 0 and 50",
        "100.700.300": "invalid salutation",
        "100.700.400": "invalid title",
        "100.700.500": "company name too long",
        "100.700.800": "identity contains no or invalid 'paper'",
        "100.700.801": "identity contains no or invalid identification value",
        "100.700.802": "identification value too long",
        "100.700.810": "specify at least one identity",
        "100.900.100": "request contains no email address",
        "100.900.101": "invalid email address (probably invalid syntax)",
        "100.900.105": "email address too long (max 50 chars)",
        "100.900.200": "invalid phone number (has to start with a digit or a '+', at least 7 and max 25 chars long)",
        "100.900.300": "invalid mobile phone number (has to start with a digit or a '+', at least 7 and max 25 chars long)",
        "100.900.301": "mobile phone number mandatory",
        "100.900.400": "request contains no ip number",
        "100.900.401": "invalid ip number",
        "100.900.450": "invalid birthdate",
        "100.900.500": "invalid recurrence mode",

        "100.100.100": "request contains no creditcard, bank account number or bank name",
        "100.100.101": "invalid creditcard, bank account number or bank name",
        "100.100.104": "invalid unique id / root unique id",
        "100.100.200": "request contains no month",
        "100.100.201": "invalid month",
        "100.100.300": "request contains no year",
        "100.100.301": "invalid year",
        "100.100.303": "card expired",
        "100.100.304": "card not yet valid",
        "100.100.305": "invalid expiration date format",
        "100.100.400": "request contains no cc/bank account holder",
        "100.100.401": "cc/bank account holder too short or too long",
        "100.100.402": "cc/bank account holder not valid",
        "100.100.500": "request contains no credit card brand",
        "100.100.501": "invalid credit card brand",
        "100.100.600": "empty CVV for VISA,MASTER, AMEX not allowed",
        "100.100.601": "invalid CVV/brand combination",
        "100.100.650": "empty CreditCardIssueNumber for MAESTRO not allowed",
        "100.100.651": "invalid CreditCardIssueNumber",
        "100.100.700": "invalid cc number/brand combination",
        "100.100.701": "suspecting fraud, this card may not be processed",
        "100.200.100": "bank account contains no or invalid country",
        "100.200.103": "bank account has invalid bankcode/name account number combination",
        "100.200.104": "bank account has invalid acccount number format",
        "100.200.200": "bank account needs to be registered and confirmed first. Country is mandate based.",
        "100.210.101": "virtual account contains no or invalid Id",
        "100.210.102": "virtual account contains no or invalid brand",
        "100.211.101": "user account contains no or invalid Id",
        "100.211.102": "user account contains no or invalid brand",
        "100.211.103": "no password defined for user account",
        "100.211.104": "password does not meet safety requirements (needs 8 digits at least and must contain letters and numbers)",
        "100.211.105": "wallet id has to be a valid email address",
        "100.211.106": "voucher ids have 32 digits always",
        "100.212.101": "wallet account registration must not have an initial balance",
        "100.212.102": "wallet account contains no or invalid brand",
        "100.212.103": "wallet account payment transaction needs to reference a registration",

        "100.550.300": "request contains no amount or too low amount",
        "100.550.301": "amount too large",
        "100.550.303": "amount format invalid (only two decimals allowed).",
        "100.550.310": "amount exceeds limit for the registered account.",
        "100.550.311": "exceeding account balance",
        "100.550.312": "Amount is outside allowed ticket size boundaries",
        "100.550.400": "request contains no currency",
        "100.550.401": "invalid currency",
        "100.550.601": "risk amount too large",
        "100.550.603": "risk amount format invalid (only two decimals allowed)",
        "100.550.605": "risk amount is smaller than amount (it must be equal or bigger then amount)",
        "100.550.701": "amounts not matched",
        "100.550.702": "currencies not matched",
    }

    return errors;
}